import { ofType } from 'redux-observable';
import {
  catchError,
  delay,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer, timer } from 'rxjs';
import { navigate } from '@reach/router';
import { httpMethods, request } from '../../../../../services/http-service';
import { UPSERT_ANAGRAFICA } from '../../data.const';
import {
  resetCurrentCreateSessionAction,
  setCurrentAnagraficaAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';
import { rootConfig } from '../../../../../config/root-config';

const upsertAnagraficaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(UPSERT_ANAGRAFICA),
    map(({ payload }: any) => {
      const {
        createdAt,
        updatedAt,
        navigationEnabled = true,
        ...rest
      } = payload;
      if (rest.id === 'crea') {
        delete rest.id;
      }
      return { body: rest, navigationEnabled };
    }),
    tap((p) => console.log(`[epic ${UPSERT_ANAGRAFICA}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, navigationEnabled }, state]) => {
      return concat(
        of(setLoaders({ anagraficaLoader: true, page: true })),
        defer(() =>
          from(
            request({ path: `anagrafica`, method: httpMethods.POST, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error(p.message);
              }
              return p?.result;
            }),
            switchMap((data) =>
              concat(
                of(setCurrentAnagraficaAction(data)),
                of(null).pipe(
                  tap(() => {
                    if (body?.id || !navigationEnabled) {
                      return; // do not navigate in case of edit
                    }
                    navigate(
                      `${rootConfig.app_path}/gestionale/anagrafiche-edit/${
                        data?.id || 'crea'
                      }`
                    ).then(() => null);
                  }),
                  delay(500),
                  switchMap(() =>
                    of(
                      setPopupInfo({
                        opened: true,
                        message: 'Operazione completata con successo',
                        timer: 3000,
                      }),
                      resetCurrentCreateSessionAction()
                    )
                  )
                )
              )
            ),
            catchError((err) => {
              console.error(`[epic ${UPSERT_ANAGRAFICA}] error`, err);
              return of(
                setPopupInfo({
                  opened: true,
                  message: 'Operazione non riuscita',
                  type: 'BAD',
                  timer: 3000,
                })
              );
            })
          )
        ),
        of(setLoaders({ anagraficaLoader: false, page: false }))
      );
    })
  );

export default upsertAnagraficaEpic;
